import { useMemo } from 'react'

import { Option } from '@joor/design-system'

import { BrandStartOrderIds } from 'modals/OrderList/StartOrderModal/StartOrderModal.ids'

import {
  DropdownOption,
  getDesignSystemOptionId,
  toDesignSystemOptions,
} from '../../BrandStartOrderModal.formatters'
import messages from '../../BrandStartOrderModal.messages'
import { StyledMultiSelectDropdown } from './DoorsDropdown.styles'

interface DoorsDropdownProps {
  options: DropdownOption[]
  value: string[]
  setSelectedDoorIds: (doorIds: string[]) => void
}

export const DoorsDropdown = ({
  options,
  value,
  setSelectedDoorIds,
}: DoorsDropdownProps) => {
  const designSystemOptions = useMemo(
    () => toDesignSystemOptions(options),
    [options],
  )

  const selectedOptions = useMemo(
    () =>
      designSystemOptions.filter((option) =>
        value.includes(getDesignSystemOptionId(option)),
      ),
    [designSystemOptions, value],
  )

  const handleSelect = ({ selected }: { selected: Option }) => {
    const selectedId = getDesignSystemOptionId(selected)
    if (value.includes(selectedId)) {
      return
    }
    setSelectedDoorIds([...value, selectedId])
  }

  const handleDeselect = ({ deselected }: { deselected: Option }) => {
    const deselectedId = getDesignSystemOptionId(deselected)
    setSelectedDoorIds(value.filter((doorId) => doorId !== deselectedId))
  }

  return (
    <StyledMultiSelectDropdown
      id={BrandStartOrderIds.DoorOptions}
      testId={BrandStartOrderIds.DoorOptions}
      labelId={BrandStartOrderIds.DoorTitle}
      label={messages.selectDoors}
      options={designSystemOptions}
      value={selectedOptions}
      translateOptions={false}
      onSelect={handleSelect}
      onDeselect={handleDeselect}
      placeholder={messages.selectOne}
    />
  )
}
